'use client'

import { aeonik, inter } from '@ethena/shared-ui/src/fonts/fonts'
import { Custom404 } from '@ethena/shared-ui/src/screens/Custom404'
import Head from 'next/head'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

import '../styles/globals.css'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="en" className={`${aeonik.variable} ${inter.variable}`}>
      <Head>
        <meta name="robots" content="noindex,nofollow" key="none" />
        <title>Ethena</title>
        <meta name="description" content="Enabling Internet Money" />
      </Head>
      <body>
        <main>
          <Custom404 title="An error occurred.  Please refresh or return to the home page." />
        </main>
      </body>
    </html>
  )
}
